import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaChevronDown,
  FaCode,
  FaDatabase,
  FaChartBar,
  FaGitAlt,
  FaDocker,
  FaPalette,
  FaMoon,
  FaSun,
} from "react-icons/fa";
import {
  DiJavascript,
  DiPython,
  DiReact,
  DiNodejs,
  DiGit,
  DiMongodb,
  DiCss3,
  DiHtml5,
} from "react-icons/di";
import {
  SiTypescript,
  SiExpress,
  SiTableau,
  SiPowerbi,
  SiMysql,
  SiMicrosoftexcel,
  SiFigma,
  SiPhp,
} from "react-icons/si";
import SearchBar from "./SearchBar";
import { useTheme } from "../context/ThemeContext";
import "../styles/Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);
  const { isDark, toggleTheme } = useTheme();

  const mainNavItems = [
    { path: "/", label: "Home" },
    { path: "/cheatsheet/html", label: "HTML" },
    { path: "/cheatsheet/css", label: "CSS" },
    { path: "/cheatsheet/javascript", label: "JavaScript" },
    { path: "/cheatsheet/react", label: "React" },
    { path: "/cheatsheet/python", label: "Python" },
    { path: "/cheatsheet/php", label: "PHP" },
  ];

  const moreNavItems = [
    { path: "/cheatsheet/typescript", label: "TypeScript" },
    { path: "/cheatsheet/ux-ui", label: "UX/UI Design" },
    { path: "/cheatsheet/nodejs", label: "Node.js" },
    { path: "/cheatsheet/express", label: "Express" },
    { path: "/cheatsheet/mongodb", label: "MongoDB" },
    { path: "/cheatsheet/sql", label: "SQL" },
    { path: "/cheatsheet/git", label: "Git" },
    { path: "/cheatsheet/docker", label: "Docker" },
    { path: "/cheatsheet/excel", label: "Excel" },
    { path: "/cheatsheet/tableau", label: "Tableau" },
    { path: "/cheatsheet/powerbi", label: "Power BI" },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isDropdownOpen) setIsDropdownOpen(false);
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          Himal Block CheatSheets
        </Link>

        <button className="mobile-menu-button" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <button
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label="Toggle dark mode"
        >
          {isDark ? <FaSun /> : <FaMoon />}
        </button>

        <div className={`navbar-links ${isMenuOpen ? "show" : ""}`}>
          <div className="navbar-search">
            <SearchBar />
          </div>

          {mainNavItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${isActive(item.path) ? "active" : ""}`}
            >
              {item.label}
            </Link>
          ))}

          <div className="more-dropdown" ref={dropdownRef}>
            <button
              className={`more-button ${isDropdownOpen ? "active" : ""}`}
              onClick={toggleDropdown}
            >
              More <FaChevronDown className={isDropdownOpen ? "rotate" : ""} />
            </button>
            <div className={`dropdown-content ${isDropdownOpen ? "show" : ""}`}>
              {moreNavItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-link ${isActive(item.path) ? "active" : ""}`}
                  onClick={() => setIsDropdownOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
